<template>
  <div class="col" style="margin-top: 150px">
    <b-tabs v-model="tabIndex" active-nav-item-class="font-weight-bold text-uppercase text-danger">
      <b-tab
        @click="handleTabClick(prodKey)"
        v-for="prodKey in Object.keys(products)"
        :key="prodKey"
        :title="products[prodKey].title" lazy>
        <glcwc-content-comm-prod-list
          inst-key="WFlIywMGaf1AqrLVAErIfQ"
          :layout="layout"
          :selected-index="selectedIndex"
          :selected-key="selectedKey"
          :ref="'ref-'+prodKey"
          gen-seo
          add-btn-confetti
          :tag-list-filter="products[prodKey].tagListFilter"
          :cp-key-list-filter="products[prodKey].keyListFilter"
          :title-link-attributes="{ href: '/shop/'+prodKey }"
          @comm-product-details="handleTabClick(prodKey, $event.detail[0])" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      selectedIndex: -1,
      selectedKey: null,
      layout: 'list',
      tabIndex: -1,
      products: {
        'red': {
          title: 'Rotweine',
          // keyListFilter: ['J7iIGyXFn5RJOMXO-dqyHQ', 'sRYZM69NKn2Yr5dJKKDNGQ', 'nKv8jMcOVbzK74EfrCY4Jg', 'k6a7Nt0VLbvyuPoxzFIpaQ', '0QtgqLDz9H4KIj9yQbXC1Q', 'WEb2ogS0Ayb017lvwSm6Ow', 'dR_D1l9CQYv88w-u1YQaXQ', 'ma0twdiGSIBk4L_DghzCUw', '0-KJYh4tCETCcRqfsl1CQQ', '8yg7HL7M2SW5SkyFydMs4A', 'mdhNFOcdqI4XgorjGSt2yg', 'scYeCl3eO4g6HUCL-vcxjA']
          tagListFilter: ['red']
        },
        'white': {
          title: 'Weißweine',
          // keyListFilter: ['QjVKDi7kbTZQXEtE1lLAOw', '-IRhPTiaCaGkrL-47LP1VA', '6ftPY7Vz9QyrgNJIuj1y5Q', '4oS8yTjCK4-XImzGsUOctw', 'Cs5kSxzSt7rWyuKMz_hB7Q', '78p9AEzBJh9j6UfknVtibw']
          tagListFilter: ['weiss']
        },
        'rose': {
          title: 'Roseweine',
          // keyListFilter: ['7r-hBL3jkSp8xQODJhE_Xg', 'twnXBb0Dr2v_kQenNOepIw']
          tagListFilter: ['rose']
        },
        'choco': {
          title: 'Schokoladen',
          keyListFilter: ['lvYark79_d3vxl4YIXLdxg', '1jbsRYarOG-b8wynMLXofw', 'UdQXUBaIOd1CuOz0Mb6bVw', 'cGE-d4KHuozsyUnN735wRA', 'opyW-GmuPog0Jeo5_EAVLg', 'lQwdr7NDe-XWdnDVwcv7OQ', 'e91-LAofjbX8pcbqT4KuHw', 'nFBoGOVyd1xR2JQ8lQ5VDA', 'h70J3xb18SYZtpbWSCQk2g', 'mli-qnYnIqVN3-q8mKyRbQ', 'ZOYnmxtkHUtuMqh6vgk7CQ']
        },
        'gifts': {
          title: 'Pakete und Geschenke',
          keyListFilter: ['N1AbOs-6_2wqo8sWe1PJWw', 'ZjlpRkI7HJgO1mmfXfTkZQ', '5i9UQrxIXtw-c_K53tR4AA', 'OMeDSyB1NVU4_LhHgnfYlg']
        },
        'cosmetics': {
          title: 'Kosmetik und Tekstilien',
          keyListFilter: []
        }
      }
    }
  }, // data
  created () {
    /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
    this.$tracker('event', 'screen_view', {
      'app_name': 'magiv',
      'screen_name': 'Shop'
    })
    console.log('TRACE-REMOVE: Shop.created: this.$route is: ', this.$route)
    if (this.$route.params.tab) {
      const _tabIndex = Object.keys(this.products).findIndex(tab => tab === this.$route.params.tab)
      console.log('TRACE-REMOVE: Shop.created: _tabIndex is: ', _tabIndex)
      if (_tabIndex > -1) {
        let _layout = 'list'
        const _selectedIndex = 0
        if (this.$route.params.key) {
          this.selectedKey = this.$route.params.key
          console.log('TRACE-REMOVE: Shop.created: this.selectedKey is: ', this.selectedKey)
          // _selectedIndex = this.products[this.$route.params.tab].keyListFilter
          //   .findIndex(key => key === this.$route.params.key)
          // console.log('TRACE-REMOVE: Shop.created: _selectedIndex is: ', _selectedIndex)
          // if (_selectedIndex > -1) {
          _layout = 'single'
          // } else {
          //   this.$router.replace('/shop/' + this.$route.params.tab)
          // }
        }
        this.tabIndex = _tabIndex
        console.log('TRACE-REMOVE: Shop.created: this.tabIndex is: ', this.tabIndex)
        this.selectedIndex = _selectedIndex
        this.layout = _layout
      }
    }
  }, // created
  mountedDisabled () {
    console.log('TRACE-REMOVE: Shop.mounted: this.$route is: ', this.$route)
    if (this.$route.params.tab) {
      const _tabIndex = Object.keys(this.products).findIndex(tab => tab === this.$route.params.tab)
      console.log('TRACE-REMOVE: Shop.mounted: _tabIndex is: ', _tabIndex)
      if (_tabIndex > -1) {
        let _layout = 'table'
        let _selectedIndex = 0
        if (this.$route.params.key) {
          _selectedIndex = this.products[this.$route.params.tab].keyListFilter
            .findIndex(key => key === this.$route.params.key)
          console.log('TRACE-REMOVE: Shop.mounted: _selectedIndex is: ', _selectedIndex)
          if (_selectedIndex > -1) {
            _layout = 'single'
          }
        }
        this.$nextTick(() => {
          this.tabIndex = _tabIndex
          this.selectedIndex = _selectedIndex
          this.layout = _layout
        })
      }
    }
  }, // mounted
  mountedOld () {
    console.log('TRACE-REMOVE: Shop.mounted: this.$route is: ', this.$route)
    // this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash)
    this.layout = 'list'
    if (this.$route.params.tab) {
      // this.tabIndex = Object.keys(this.products).findIndex(tab => tab === this.$route.params.tab)
      this.$nextTick(() => {
        this.tabIndex = Object.keys(this.products).findIndex(tab => tab === this.$route.params.tab)
        // this.$nextTick(() => {
        //   const _ref = 'ref-' + this.$route.params.tab
        //   this.$refs[_ref][0].vueComponent.handleActive()
        // })
        if (this.$route.params.key) {
          this.selectedIndex = this.products[this.$route.params.tab].keyListFilter
            .findIndex(key => key === this.$route.params.key)
          if (this.selectedIndex > -1) {
            this.layout = 'single'
          }
          // console.log('TRACE-REMOVE: Shop.mounted.nt: this.layout is: ', this.layout)
          // console.log('TRACE-REMOVE: Shop.mounted.nt: this.tabIndex is: ', this.tabIndex)
          // console.log('TRACE-REMOVE: Shop.mounted.nt: this.selectedIndex is: ', this.selectedIndex)
        }
      })
      // if (this.$route.params.key) {
      //   this.selectedIndex = this.products[this.$route.params.tab].keyListFilter
      //     .findIndex(key => key === this.$route.params.key)
      //   if (this.selectedIndex > -1) {
      //     this.layout = 'single'
      //   }
      // }
      // console.log('TRACE-REMOVE: Shop.mounted: this.layout is: ', this.layout)
      // console.log('TRACE-REMOVE: Shop.mounted: this.tabIndex is: ', this.tabIndex)
      // console.log('TRACE-REMOVE: Shop.mounted: this.selectedIndex is: ', this.selectedIndex)
    }
  }, // mountedOld
  // async created () {
  //   /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
  //   this.$tracker('event', 'screen_view', {
  //     'app_name': 'magiv',
  //     'screen_name': 'Shop'
  //   })
  // }, // created
  watch: {
    tabIndex: function (nv, ov) {
      console.log('TRACE-REMOVE: Shop.watch.tabIndex: ov/nv is: ', ov, nv)
    },
    selectedIndex: function (nv, ov) {
      console.log('TRACE-REMOVE: Shop.watch.selectedIndex: ov/nv is: ', ov, nv)
    }
  }, // watch
  methods: {
    handleTabClick (tab, key) {
      console.log('TRACE-REMOVE: Shop.handleTabClick: tab/key is: ', tab, key)
      if (!key) {
        this.layout = 'list'
        // this.$router.replace('/shop/'+tab)
        this.$router.push('/shop/' + tab)
        // const _ref = 'ref-' + tab
        // this.$refs[_ref][0].vueComponent.handleActive()
      } else {
        // this.selectedIndex = this.products[this.$route.params.tab].keyListFilter
        //   .findIndex(k => k === key)
        console.log('TRACE-REMOVE: Shop.handleTabClick: this.selectedIndex is: ', this.selectedIndex)
        // if (this.selectedIndex > -1) {
        this.layout = 'single'
        this.$router.push('/shop/' + tab + '/' + key)
        // }
      }
    }
  }, // methods
  components: {
  } // components
}
</script>
<style scoped>
</style>
